module.exports = __webpack_public_path__ + "img/google-news-source.952033e3.svg";